<template>
  <div>
    <!-- Trackable Ad 3 Image -->
    <v-img
      src="https://firebasestorage.googleapis.com/v0/b/safaschools-a6f8c.appspot.com/o/300x600.png?alt=media&token=d5c78ac0-9566-4f68-980c-89bbb9e8fdfc"
      @click="handleClick"
      style="cursor: pointer;height:94vh"

    ></v-img>


   
  </div>
</template>

<script>
import { onMounted } from 'vue';
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  increment
} from "firebase/firestore";
import { firebaseApp } from "../firebaseConfig";

const db = getFirestore(firebaseApp);

export default {
  name: 'TrackableImageAd3',
  data() {
    return {
      ad3Views: 0,
      ad3Clicks: 0
    };
  },
  async mounted() {
    // Increment view count on mount, then fetch latest stats
    await this.incrementAd3View();
    await this.fetchAd3Stats();
  },
  methods: {
    // Fetch the current ad3Views and ad3Clicks from Firestore
    async fetchAd3Stats() {
      const statsRef = doc(db, 'durbanjuly_farpost_stats', 'counts');
      const statsSnap = await getDoc(statsRef);
      if (statsSnap.exists()) {
        const data = statsSnap.data();
        this.ad3Views = data.ad3Views || 0;
        this.ad3Clicks = data.ad3Clicks || 0;
      } else {
        // If doc doesn't exist yet, initialize local state
        this.ad3Views = 0;
        this.ad3Clicks = 0;
      }
    },

    // Increment the Ad 3 view count
    async incrementAd3View() {
      const statsRef = doc(db, 'durbanjuly_farpost_stats', 'counts');
      const statsSnap = await getDoc(statsRef);
      if (statsSnap.exists()) {
        await updateDoc(statsRef, {
          ad3Views: increment(1)
        });
      } else {
        await setDoc(statsRef, {
          ad3Views: 1,
          ad3Clicks: 0
        });
      }
    },

    // Increment the Ad 3 click count
    async incrementAd3Click() {
      const statsRef = doc(db, 'durbanjuly_farpost_stats', 'counts');
      const statsSnap = await getDoc(statsRef);
      if (statsSnap.exists()) {
        await updateDoc(statsRef, {
          ad3Clicks: increment(1)
        });
      } else {
        await setDoc(statsRef, {
          ad3Views: 0,
          ad3Clicks: 1
        });
      }
    },

    // Handle click: update Firestore, refresh stats, then open landing page in new tab
    async handleClick() {
      await this.incrementAd3Click();
      await this.fetchAd3Stats();
      window.open(
        'http://static.clvads.com/durbanjuly_farpost/index.html',
        '_blank',
        'noopener,noreferrer'
      );
    }
  }
};
</script>

<style scoped>
.v-image--image {
  transition: opacity 0.3s ease;
}
.v-image--image:hover {
  opacity: 0.8;
}
.ad-stats p {
  margin: 0.25rem 0;
  font-size: 0.9rem;
}
</style>
